import { Component, OnInit } from '@angular/core';
import { QuizSession } from '../model/quiz-session.model';
import { TeacherService } from '../teacher/teacher.service';

@Component({
  selector: 'app-quiz-session',
  templateUrl: './quiz-session.component.html',
  styleUrls: ['./quiz-session.component.scss']
})
export class QuizSessionComponent implements OnInit {

  quizSessions: QuizSession[];
  displayedColumns: string[] = [
    'quizSession.storybookName',
    'quizSession.studentUsername',
    'quizSession.quizScore',
    'quizSession.createdDate'
  ];
  tableReady: boolean = false;
  items = [];
  pageOfItems: Array<any>;
  constructor(
    private teacherService: TeacherService
  ) { }

  ngOnInit(): void {
    this.quizSessions = [];
    let avatarUser = JSON.parse(localStorage.getItem("avatarUser"));
    this.teacherService.getAllQuizSessions(avatarUser.teacherId).subscribe((allQuizSessions: QuizSession[]) => {
      console.log(allQuizSessions);
      this.quizSessions = allQuizSessions;
      this.items = this.quizSessions;

      this.displayTable();
    });
  }

  displayTable(){
    this.tableReady = true;
  }


  onChangePage(pageOfItems: Array<any>) {
    // update current page of items
    this.pageOfItems = pageOfItems;
  }
}
